module.exports = __webpack_public_path__ + "static/img/数据增值.935b179c.png";